import { render, staticRenderFns } from "./recommend_pfizer.vue?vue&type=template&id=14e2652c"
import script from "./recommend_pfizer.vue?vue&type=script&lang=js"
export * from "./recommend_pfizer.vue?vue&type=script&lang=js"
import style0 from "./recommend_pfizer.vue?vue&type=style&index=0&id=14e2652c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports